import { Alert, Button, Dialog, DialogContent } from '@mui/material';
import { FallbackProps } from 'react-error-boundary';
import { useAppDispatch } from '@reduxStore';
import { removeModal } from './modalSlice';

import styles from './ApplicationModal.module.css';

/**
 * Rendered in place of the modal stack when a modal throws, so the page behind it stays usable instead of the
 * whole application falling back to the error page. Closing drops the top-most modal (the one that threw) and
 * re-renders whatever remains in the queue.
 */
export default function ModalErrorFallback({ resetErrorBoundary }: FallbackProps) {
	const appDispatch = useAppDispatch();

	const handleClose = () => {
		appDispatch(removeModal());
		resetErrorBoundary();
	};

	return (
		<Dialog
			open
			slotProps={{
				paper: { className: styles.paper }
			}}
		>
			<div className={styles.header}>
				Error
				<div className={styles.actions}>
					<Button
						variant='outlined'
						sx={{ marginRight: '4px' }}
						onClick={handleClose}
					>
						Close
					</Button>
				</div>
			</div>

			<DialogContent>
				<Alert severity='error'>
					An unexpected error occurred while displaying this window. Close it and try again. If the problem continues, please contact
					support.
				</Alert>
			</DialogContent>
		</Dialog>
	);
}
